import React, { Component } from "react";
import { Button, DropdownButton, Glyphicon, MenuItem} from "react-bootstrap";
import getMeasureTitle from "../../utils/Measure";
import "../../css/form/DropdownMeasure.css";

export default class Dropdown extends React.Component {

    constructor(props) {
        super(props);
        this.state = { title: 'Select Measure' };
    }

    componentWillMount () {
        var id    = parseInt(this.props.id);
        this.changeDDIdAndTitle(id)
    }

    componentDidUpdate(previousProps, previousState) {
        var new_id = this.props.id;

        if(previousProps.id !== this.props.id) {

            var id = parseInt(new_id);
            this.changeDDIdAndTitle(id)
        }
    }

    changeDDIdAndTitle(id) {
        var title = getMeasureTitle(id);

        this.setState({
            id:    id,
            title: title,
        });
    }

    onSelect(event) {
        var id    = event[0];
        var title = event[1]

        this.setState({
            id:    id,
            title: title
        });

        this.props.changeId(id); // update id in parent
    }

    render() {
        //var category = ["Sets", "Repetitions (REPS)", "Rest"]
        /* category.map((i) => <MenuItem key={i} eventKey={i}>{i}</MenuItem>) */
        var show_none = this.props.showNoneOption;
        var none = <MenuItem eventKey={["100", "None"]} >None</MenuItem>
        var divider = <MenuItem divider />;
        if(!show_none) {
            none = "";
            divider = "";
        }

        return (
            <DropdownButton id        = "DropdownMeasure"
                            onSelect  = {(event) => this.onSelect(event)}
                            title     = {this.state.title}
                            className = "dropdownMeasureCaret customButton">
                       { divider }
                       { none }
                       <MenuItem divider />
                       <MenuItem header><b>MEASURE</b></MenuItem>
                       <MenuItem eventKey={["1", "Sets"]} name="Sets">Sets</MenuItem>
                       <MenuItem eventKey={["2", "Repetitions (Reps)"]} >Repetitions (Reps)</MenuItem>
                       <MenuItem eventKey={["5", "Reps per side"]} >Reps per side</MenuItem>
                       <MenuItem eventKey={["6", "Cluster set"]} >Cluster Set</MenuItem>
                       { /* already permanently listed: <MenuItem eventKey={["3", "Rest"]} >Rest</MenuItem> */ }

                       <MenuItem divider />
                       <MenuItem header><b>WEIGHT</b></MenuItem>
                       <MenuItem eventKey={["10", "Pounds (Lbs)"]} >Pounds (Lbs)</MenuItem>
                       <MenuItem eventKey={["11", "Kilograms (Kgs)"]} >Kilograms (Kgs)</MenuItem>
                       <MenuItem eventKey={["12", "Percent of Max (%)"]} >Percent of Max (%)</MenuItem>

                       <MenuItem divider />
                       <MenuItem header><b>TIME</b></MenuItem>
                       <MenuItem eventKey={["20", "Time (Min:Sec)"]} >Time (Min:Secs)</MenuItem>
                       <MenuItem eventKey={["21", "Seconds (Secs)"]} >Seconds (Secs)</MenuItem>

                       <MenuItem divider />
                       <MenuItem header><b>DISTANCE</b></MenuItem>
                       <MenuItem eventKey={["30", "Feet"]} >Feet</MenuItem>
                       <MenuItem eventKey={["31", "Yards"]} >Yards</MenuItem>
                       <MenuItem eventKey={["32", "Miles"]} >Miles</MenuItem>
                       <MenuItem eventKey={["33", "Inches"]} >Inches</MenuItem>
                       <MenuItem eventKey={["34", "Meters"]} >Meters</MenuItem>
                       <MenuItem eventKey={["35", "Height in Inches (Height)"]} >Height in Inches (Height)</MenuItem>
                       <MenuItem eventKey={["36", "Laps"]} >Laps</MenuItem>

                       <MenuItem divider />
                       <MenuItem header><b>OUTPUT</b></MenuItem>
                       <MenuItem eventKey={["40", "Calories (Cals)"]} >Calories (Cals)</MenuItem>
                       <MenuItem eventKey={["48", "Rate of Perceived Exertion"]} >Rate of Perceived Exertion</MenuItem>
                       <MenuItem eventKey={["41", "Velocity in meters/second"]} >Velocity in meters/second</MenuItem>
                       <MenuItem eventKey={["42", "Velocity miles/hour"]} >Velocity miles/hour</MenuItem>
                       <MenuItem eventKey={["43", "Velocity kilometers/hour"]} >Velocity kilometers/hour</MenuItem>
                       <MenuItem eventKey={["44", "Watts"]} >Watts</MenuItem>

                      <MenuItem divider />
                      <MenuItem header><b>OTHER</b></MenuItem>
                      <MenuItem eventKey={["45", "Breaths"]} >Breaths</MenuItem>
                      <MenuItem eventKey={["46", "Breaths per side"]} >Breaths per side</MenuItem>
                      <MenuItem eventKey={["47", "Seconds per side"]} >Seconds per side</MenuItem>
             </DropdownButton>
         );
     }

}



// WEBPACK FOOTER //
// ./src/components/form/DropdownMeasure.js